import { render, staticRenderFns } from "./RandomImage.vue?vue&type=template&id=49a60777&"
import script from "./RandomImage.vue?vue&type=script&lang=ts&"
export * from "./RandomImage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports